export default "__VITE_ASSET__fd8200fc__"